module.exports = __webpack_public_path__ + "img/2.76d33acb.jpg";